import { RouteObject } from 'react-router-dom'
import { PageLayout } from '../../../common/app'
import { default as Roster } from '.'

const basePath = '/time/roster'
// The rebuilt roster pages live under their own path while the old ones stay.
const newBasePath = '/time/roster-new'

export const rosterRoutes: RouteObject[] = [
  {
    path: `${basePath}/:rosterId/publish`,
    element: (
      <PageLayout displayLeftTitle={false}>
        <Roster.Publish.Component />
      </PageLayout>
    ),
    loader: Roster.Publish.Loader,
  },
  {
    path: `${basePath}/templates`,
    element: (
      <PageLayout title={'Roster Templates'} displayLeftTitle={false}>
        <Roster.Templates.Component />
      </PageLayout>
    ),
    loader: Roster.Templates.Loader,
  },
  {
    path: `${newBasePath}/edit`,
    element: (
      <PageLayout
        title={'Roster Editor'}
        htmlTitleOnly
        displayLeftTitle={false}
        fixedHeight
      >
        <Roster.Edit.Component />
      </PageLayout>
    ),
    loader: Roster.Edit.Loader,
  },
  {
    path: `${newBasePath}/templates`,
    element: (
      <PageLayout displayLeftTitle={false} fixedHeight>
        <Roster.ManageRosterTemplates.Component />
      </PageLayout>
    ),
    loader: Roster.ManageRosterTemplates.Loader,
  },
  {
    path: `${newBasePath}/overview`,
    element: (
      <PageLayout displayLeftTitle={false}>
        <Roster.Overview.Component />
      </PageLayout>
    ),
    loader: Roster.Overview.Loader,
  },
  {
    path: `${newBasePath}/shift-report`,
    element: (
      <PageLayout displayLeftTitle={false}>
        <Roster.ShiftReport.Component />
      </PageLayout>
    ),
    loader: Roster.ShiftReport.Loader,
  },
  {
    path: `${basePath}/copy`,
    element: (
      <PageLayout displayLeftTitle={false}>
        <Roster.Copy.Component />
      </PageLayout>
    ),
    loader: Roster.Copy.Loader,
  },
]
